import * as types from './actionTypes';


export const get = (year, month) =>{
	return{
    type: types.GET_CALENDAR_DATA_REQUEST,
    year,
    month
  }
};
export const getDataSuccess = data => {
	return {
		type: types.GET_CALENDAR_DATA_SUCCESS,
		payLoad: {data, loading: false}
	};
};
export const getDataFailure = () => {
	return {
		type: types.GET_CALENDAR_DATA_FAILURE,
		payLoad: {loading: false}
	};
};